<template lang="pug">
v-layout.px-3(column)
    v-subheader.pl-4.mt-3.pb-3 Абонемент в горно-лыжную базу
    v-layout(:class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
      v-card(width="100%")
        v-card-text(v-if="!isRidderRegion")
          v-list.overflow-x-hidden
            v-list-tile.px-2(avatar ripple)
              v-list-tile-content
                | Данные для этого региона отсуствует
        v-card-text(v-if="isRidderRegion")
          v-list.overflow-x-hidden
              v-list-tile.px-2(avatar ripple)
                v-list-tile-content
                  table(style="width:70%")
                    tbody(style="width:100%")
                      tr
                        td(style="text-align:center; vertical-align: top;")
                          b
                            | ИНФОРМАЦИЯ ПО АБОНЕМЕНТАМ НА ГОРНОЛЫЖНЫЕ БАЗЫ:
                  | Профсоюзные комитеты ППО ТОО «Казцинк» г.Риддер, ППО ПК «Казцинкмаш» и ППО «РМП МК» предоставляют членам профсоюза индивидуальные абонементы на горнолыжные базы  «Эдельвейс» (2 район) и «StardustCamp» (Верхняя Хариузовка) со скидкой 50%. При оплате абонемента удерживается подоходный налог в размере 10%. 
                  br
                  | Для получения абонементов необходимо обращаться профсоюзные комитеты по месту работы.
                  br
                  br             
                  table(style="width:70%")
                    tbody(style="width:100%")
                      tr
                        td(style="text-align:center; vertical-align: top;")
                          b
                            | Прайс на услуги подъемника для членов профсоюза
                      tr
                        td(style="text-align:center; vertical-align: top;")
                          b
                            | ППО ТОО «Казцинк» г.Риддер, ППО «РМП МК» и ППО ПК «Казцинкмаш»
                      tr
                        td(style="text-align:center; vertical-align: top;")
                          b
                            | Сезон «Зима 2023-2024 гг.»
                  br 
                  table(style="border: 1px solid black; border-collapse: collapse; width:70%")
                    tbody(style="width:100%")
                      tr
                        td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; vertical-align: top;")
                          b
                            | Категория
                        td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center; vertical-align: top;")
                          b
                            | Общая стоимость/тенге                          
                        td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center; vertical-align: top;")
                          b
                            | Оплата члена профсоюза с ИПН, тенге
                      tr
                        td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; ")
                          b
                            | Одна путёвка на горнолыжную базу «Эдельвейс»
                        td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center;")
                          | 27 000               
                        td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center;")
                          | 14 850
                      tr
                        td(style="border: 1px solid black; border-collapse: collapse; width:25%; text-align:center; ")
                          b
                            | Одна путёвка на горнолыжную базу «StardustCamp»
                        td(style="border: 1px solid black; border-collapse: collapse; width:35%; text-align:center;")
                          | 24 000
                        td(style="border: 1px solid black; border-collapse: collapse; width:40%; text-align:center;")
                          | 13 200
</template>
  
<script>
export default {
  data() {
    return {
      iin: null,
      isUKRegion: false,
      isRidderRegion: false
    }
  },

  computed: {
    profile(){
      return this.$store.getters['auth/profile'];
    },
    employees(){
      return this.$store.getters['data/employees'];
    },
  },

  created() {
    this.iin = this.profile.userName;
    this.search(this.profile.userName);
  },

  methods: {
    search(iin){
      return this.$store.dispatch('data/getUser', iin)
    },
  },

  watch: {
    'employees'(employees) {
      if(this.employees.length > 0){
        if(this.employees[0].data){
          let data = this.employees[0].data;
          if(data.region){
            this.isUKRegion = (data.region.id === 'oskemen');
            this.isRidderRegion = (data.region.id === 'ridder') || (this.profile.userName === '830501301242');
            
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus"></style>
  


// WEBPACK FOOTER //
// src/components/activity/Ski.vue